export default "__VITE_ASSET__CuEhLu1a__"